import React from 'react';
import '../layout/AccountModal.css';

const Modal = ({ isOpen, onClose, onConfirm, title, message, confirmText = "Confirm", cancelText = "Cancel" }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[9999] px-4">
      <div className="absolute inset-0 bg-black/40 dark:bg-black/60 backdrop-blur-sm" onClick={onClose} aria-hidden="true" />
      <div
        className="account-modal account-modal-shape relative w-full max-w-[400px] bg-white dark:bg-[#1a1a1a] shadow-xl border border-gray-200 dark:border-[#2a2a2a] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2" style={{ fontFamily: 'var(--chat-font-family)' }}>
            {title}
          </h3>
          <p className="text-sm text-gray-600 dark:text-[#999999]" style={{ fontFamily: 'var(--chat-font-family)' }}>
            {message}
          </p>
        </div>
        <div className="px-6 pb-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="account-modal-btn px-4 py-2.5 text-sm text-gray-600 dark:text-[#999999] transition-colors"
            style={{ fontFamily: 'var(--chat-font-family)' }}
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="account-modal-btn account-modal-btn-destructive px-4 py-2.5 text-sm transition-colors"
            style={{ fontFamily: 'var(--chat-font-family)' }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal; 